import { directAxiosInstance } from "./api"
import { safeLogger } from "@commonUtils"

export const apiResponseLogger = (response) => {
    try {
        safeLogger.debug({
            message: `${JSON.stringify(response.data)}`,
            uri: response.request.path,
        })
    } catch (error) {
        safeLogger.error({
            message: "Error while logging API responses",
            traceback: error && error.message,
        })
    }
}

export const isAdmin = (userRoles) => {
    // I think "ROLE_CCARE" should be "ROLE_CARE", but keeping it the same as this is what we have in HKP
    if (userRoles?.includes("ROLE_ADMIN") || userRoles?.includes("ROLE_CCARE")) {
        return true
    }
    return false
}

export const convertIntoSnakeCase = (str) => {
    return (
        str &&
        str
            .replace(/\s+/g, "_")
            .replace(/([a-z])([A-Z])/g, "$1_$2")
            .replace(/-+/g, "_")
            .replace(/([a-zA-Z])(\d)/g, "$1_$2")
            .toLowerCase()
    )
}

export const isTelesales = (userRoles) => {
    if (
        userRoles?.includes("ROLE_TELESALES") ||
        userRoles?.includes("ROLE_OFFLINE_INBOUND_TELESALES") ||
        userRoles?.includes("ROLE_OFFLINE_OUTBOUND_TELESALES")
    ) {
        return true
    }
    return false
}
export const autoLogin = (data) => {
    const options = {
        url: "auth/auto_login",
        method: "POST",
        data,
    }
    return directAxiosInstance()(options)
        .then((data) => {
            return Promise.resolve(data)
        })
        .catch((err) => {
            return Promise.reject(err)
        })
}

export const openInGoogleMaps = (latitude, longitude) => {
    if (!latitude || !longitude) return null
    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15`
    if (window) {
        window.open(mapUrl, "_blank") // Opens the map in a new tab
    }
}
export const formatErrorMsg = (msg) => (msg ? `Error: ${msg}` : "")
